import * as R from "ramda";
import React, {Component, Fragment} from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleSpacerLine from "../../../../../modules/SimpleSpacerLine";
import FlexView from "react-flexview";
import {FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";

class HeaderInputModifying extends Component {
    render() {
        return (
            <Fragment>
                <div style={{marginBottom: "50px"}}>
                    <div className="grid grid-2x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleInput
                                id="input_text_sales_invoice_number"
                                name="salesInvoiceNumber"
                                label="No. Faktur Jual"
                                readOnly
                                value={this.props.dataDetail.factureNo}
                            />
                            <SimpleInput
                                id="input_text_book_number"
                                name="bookNumber"
                                label="No. Buku"
                                readOnly
                                value={this.props.dataDetail.bookNo}
                            />
                            <SimpleInput
                                id="input_text_sales_invoice_date"
                                name="salesInvoiceDate"
                                label="Tanggal Pengajuan"
                                readOnly
                                value={this.props.dataDetail.bbnDate}
                            />
                            <SimpleInput
                                id="input_text_nama_variant"
                                name="namaVariant"
                                label="Nama Varian"
                                readOnly
                                value={this.props.dataDetail.variant?.namaVariant}
                            />
                            <SimpleInput
                                id="input_text_nama_warna"
                                name="namaWarna"
                                label="Nama Warna"
                                readOnly
                                value={this.props.dataDetail.warna?.namaWarnaKomersil}
                            />
                        </div>
                        <div id="grid-2">
                            <SimpleInput
                                id="input_text_nama_stnk"
                                name="stnkName"
                                label="Nama STNK"
                                readOnly
                                value={this.props.dataDetail.stnkName}
                            />
                            <SimpleInput
                                id="input_text_nik_stnk"
                                name="nikSTNK"
                                label="NIK STNK"
                                readOnly
                                value={this.props.dataDetail.stnkNIK}
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="buyerName"
                                label="Nama Pembeli"
                                readOnly
                                value={this.props.dataDetail.buyer}
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="Nomor Rangka"
                                readOnly
                                value={this.props.dataDetail.frameNumber}
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="Nomor Mesin"
                                readOnly
                                value={this.props.dataDetail.engineNumber}
                            />
                        </div>
                    </div>

                    <SimpleSpacerLine/>

                    <FlexView style={{justifyContent: "space-between", gap: "20px", marginBottom: "20px"}}>
                        <FlexView column style={{width: "50%", gap: "20px"}}>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Tipe Payment</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    name="paymentType"
                                    className="txt txt-sekunder-color"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={this.props.dataDetail.payment?.paymentType}
                                />
                            </FlexView>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Nilai Harus Setor (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="depositValue"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.payment?.amountToPay})}
                                />
                            </FlexView>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Biaya Lain-Lain yang Dibebankan Konsumen (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="otherCost"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.payment?.otherCost})}
                                />
                            </FlexView>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Pajak Progresif (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="otherCost"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.payment?.progressive})}
                                />
                            </FlexView>
                            <SimpleSpacerLine/>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Total (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="totalCost"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.payment?.totalCost})}
                                />
                            </FlexView>
                        </FlexView>
                        <FlexView column hAlignContent={"right"} style={{width: "50%"}}>
                            <table border="1"
                                   style={{
                                       width: "100%",
                                       textAlign: "left",
                                       borderCollapse: "collapse",
                                       border: "1px solid #ccc",
                                       marginBottom: "20px"
                                   }}>
                                <thead style={{backgroundColor: "#f5f5f5"}}>
                                <tr>
                                    <th style={{border: "1px solid #ccc", padding: "15px"}}>Nomor BKM</th>
                                    <th style={{border: "1px solid #ccc", padding: "15px"}}>Rupiah</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.props.dataDetail.bkm && this.props.dataDetail.bkm.length > 0 && this.props.dataDetail.bkm.map((item) => {
                                        return (
                                            <tr>
                                                <td style={{border: "1px solid #ccc", padding: "15px"}}>{item.bkmCode}</td>
                                                <td style={{
                                                    border: "1px solid #ccc",
                                                    padding: "15px"
                                                }}>{FormatCurrencyWithoutSymbol({number: item.bkmCost})}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>

                            {/* <table border="1"
                                   style={{
                                       width: "100%",
                                       textAlign: "left",
                                       borderCollapse: "collapse",
                                       border: "1px solid #ccc",
                                       marginBottom: "20px"
                                   }}>
                                <thead style={{backgroundColor: "#f5f5f5"}}>
                                <tr>
                                    <th style={{border: "1px solid #ccc", padding: "15px"}}>Nomor BBM</th>
                                    <th style={{border: "1px solid #ccc", padding: "15px"}}>Rupiah</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.props.dataDetail.bbm && this.props.dataDetail.bbm.length > 0 && this.props.dataDetail.bbm.map((item) => {
                                        return (
                                            <tr>
                                                <td style={{border: "1px solid #ccc", padding: "15px"}}>{item.bbmCode}</td>
                                                <td style={{
                                                    border: "1px solid #ccc",
                                                    padding: "15px"
                                                }}>{FormatCurrencyWithoutSymbol({number: item.bbmCost})}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table> */}
                        </FlexView>
                    </FlexView>

                    <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                        <FlexView column style={{width: "50%", gap: "20px"}}>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Selisih (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="selisih"
                                    style={{
                                        width: "50%",
                                        textAlign: "right",
                                        fontWeight: "bold",
                                        backgroundColor: "#E6E6E6",
                                        color: !R.isNil(this.props.dataDetail.selisih)
                                        && R.lt(this.props.dataDetail.selisih, 0) ? "red" : "green"
                                    }}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.selisih})}
                                />
                            </FlexView>
                        </FlexView>
                        <FlexView column style={{width: "50%", gap: "20px"}}>
                            <FlexView style={{justifyContent: "space-between", gap: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Total (Rp)</h4>
                                </div>
                                <input
                                    disabled
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    name="totalBKMBBM"
                                    style={{width: "50%", textAlign: "right", backgroundColor: "#E6E6E6"}}
                                    value={FormatCurrencyWithoutSymbol({number: this.props.dataDetail.totalBbmBkm})}
                                />
                            </FlexView>
                        </FlexView>
                    </FlexView>
                </div>

            </Fragment>
        )
    }
}

export default HeaderInputModifying;